import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    title: 'Web Portal Users',
  },
})
